export default "__VITE_ASSET__DnDrNjrT__"